import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
const App = () => {
  const isAuthed = Boolean(
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    (localStorage.getItem("isAuthenticated") === "true")
  );
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={isAuthed ? <AdminLayout /> : <Navigate to="/auth/sign-in" replace />} />
      <Route path="/" element={<Navigate to={isAuthed ? "/admin" : "/auth/sign-in"} replace />} />
    </Routes>
  );
};

export default App;
